module.exports = __webpack_public_path__ + "img/schedule-time.dc58a3d2.svg";